/**
 * 기본 메뉴 설정
 * 회사코드별 설정이 없을 때 사용되는 기본 설정입니다.
 */
export const DEFAULT_MENU_CONFIG = {
  // 게임별 활성화 상태
  games: {
    sports: true,      // 스포츠 게임
    minigame: true,   // 미니게임
    casino: true,      // 카지노
    slot: true,        // 슬롯
  },
  
  // 기능별 활성화 상태
  features: {
    betting: true,     // 베팅 관리
    settlement: true,  // 정산 관리
    userManagement: true, // 사용자 관리
    adminSettings: true,  // 관리자 설정
  },
  
  // 메뉴별 상세 설정
  menuItems: {
    // 베팅 내역 메뉴
    betting: {
      sports: true,
      minigame: true,
      casino: true,
      slot: true,
    },
    
    // 미니게임 관련 메뉴
    minigame: {
      close: true,
      dhpowerball: {
        result: true,
        odds: true,
        setting: true,
      },
      dhpowerladder: {
        result: true,
        odds: true,
        setting: true,
      },
    },
  }
};

